import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import {InputNumber} from 'antd'

@inject('store') @observer
class Capital extends Component {
  numberChange = (value) => {
    this.props.store.backtest.single.change('capital', value)
  }
  render() {
    const {tab} = this.props
    const {backtest} = this.props.store
    const {data} = backtest.single
    let capital = ''
    if (tab === 'total') {
      capital = data.capital
    } else if (tab === 'byticker') {
      capital = data.pnl_by_ticker_total_capital
    } else {
      let tableRow = backtest.tables.pnlByTicker.data.find(row => row.ticker === tab)
      capital = tableRow?.capital
    }
    return(
      <div>
        <label>Capital</label>
        <InputNumber
          onChange={this.handleChange}
          value={capital}
          disabled={true}
          formatter={value => `$${value.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
          parser={value => value.replace(/[^0-9.]+/g, '')}
          size='large'
        />
      </div>
    )
  }
}

export default Capital
